import { Environment } from '@uplift/store';

export const environment: Environment = {
  appNameSpace: 'uplift-auth',
  production: true,
  sentryDSN: process.env.NX_PUBLIC_SENTRY_DSN,
  restApi: process.env.NX_PUBLIC_REST_API,
  authUrl: process.env.NX_PUBLIC_AUTH_URL,
};
